import styled, { css } from "styled-components";

export const InputLayout = styled.div<{
  isError?: boolean;
  noBorder?: boolean;
}>`
  display: flex;
  flex-direction: column;

  input {
    padding: 1.2rem 1.4rem;
    border: ${({ theme, noBorder }) =>
      noBorder ? "none" : `1px solid ${theme.color.stroke.light}`};
    border-radius: 0.5rem;
    ${({ theme }) => theme.typography.body1.regular};

    ::placeholder {
      color: ${({ theme }) => theme.color.text.placeholder};
    }
    :hover {
      border: ${({ theme, noBorder }) =>
        noBorder ? "none" : `1px solid ${theme.color.stroke.dark}`};
    }
    :focus {
      outline: none;
      border: ${({ theme, noBorder }) =>
        noBorder ? "none" : `1px solid ${theme.color.stroke.primary}`};
    }

    :disabled {
      background-color: ${({ theme }) => theme.color.background.light};
      color: ${({ theme }) => theme.color.text.disabled};
    }

    ${({ isError, theme }) =>
      isError &&
      css`
        border: 1px solid ${theme.color.text.danger};
        :hover {
          border: 1px solid ${theme.color.text.danger};
        }
        :focus {
          border: 1px solid ${theme.color.text.danger};
        }
      `}

    ${({ theme }) => css`
      ${theme.media.small} {
        ${theme.typography.body3.regular};
        padding: 1.1rem 1.4rem;

        ::placeholder {
          ${theme.typography.body3.regular};
        }
      }
    `}
  }

  label {
    margin-top: 0.6rem;
    padding-left: 1.4rem;
    ${({ theme }) => theme.typography.body3.regular};
    color: ${({ theme }) => theme.color.text.danger};
  }
`;
